<template>
	<div class="cour">
		<div class="tab">
			<!-- <div class="lay-tishi">
				<div><img src="../../assets/wangcheng.svg" />
				</div>
				<div>完成所有学时方可进入考试</div>
			</div> -->
			<div class="tag">
				<el-tag :type="year==''? '' : 'info'" size="small" @click="Year(undefined)">
					全部课程
				</el-tag>
				<el-tag :type="item==year ? '' : 'info'" size="small" v-for="(item,index) in Yeardata" :key="index"
					@click="Year(item)">
					{{item}}年
				</el-tag>
				<div class="grid-red"><i class="el-icon-warning"></i>温馨提示: 完成所有学时方可进入考试</div>
			</div>
			<div class="list" style="padding-bottom: 10px;">
				<div class="listitem" v-for="(item,indexs) in listnew" :key="indexs"
					v-if="item.arrive===1 &&item.is_vip===1 || item.bz===1">
					<div class="list-img"><img :src="$cdn+item.cover_image" />
					</div>
					<div class="list-tit">{{item.title}}</div>
					<div class="list-time">课程结束时间:{{item.edatetime}}</div>
					<div class="list-start">
						<div class="list-start-img" v-if="item.courseType ===7">
							<img src="../../assets/index/01.png" />
						</div>
						<div class="list-start-img" v-if="item.courseType ===2">
							<img src="../../assets/index/02.png" />
						</div>

						<div class="list-start-img" v-if="item.courseType ===3">
							<img src="../../assets/index/04.png" />
						</div>
						<div class="list-start-img" v-if="item.courseType ===6">
							<img src="../../assets/index/05.png" />
						</div>
						<div class="list-start-img" v-if="item.courseType ===1">
							<img src="../../assets/index/06.png" />
						</div>
						<div class="list-start-img" v-if="item.courseType ===4">
							<img src="../../assets/index/07.png" />
						</div>
						<div class="list-start-img" v-if="item.courseType ===8 || item.courseType ===5">
							<img src="../../assets/index/03.png" />
						</div>
						<div class="list-start-cont">
							<div>{{item.tips}}</div>
							<div>
								<div>
									<el-button v-if="item.courseType ===7" type="primary" size="mini"
										@click="play(item)">去缴费</el-button>
									<el-tag v-else-if="item.courseType ===2" type="info" size="medium">未开始
									</el-tag>
									<el-button type="primary" v-else-if="item.courseType ===1" size="mini"
										@click="study(item)">开始学习</el-button>
									<el-button type="success" v-else-if="item.courseType ===4" size="mini"
										@click="exam(item)">开始考试</el-button>
									<el-tag v-else-if="item.courseType ===3" type="info" size="medium">
										已结束
									</el-tag>

									</el-tag>
									<el-tag v-else-if="item.courseType ===6" type="success" effect="dark" size="medium">
										考试完成
									</el-tag>
									<el-tag v-else-if="item.courseType ===9" type="info" size="medium">
										课程未开始
									</el-tag>
									<el-tag v-else-if="item.courseType ===10" type="info" size="medium">
										暂停缴费
									</el-tag>
									<el-tag v-else type="info" size="medium">课程已过期</el-tag>
								</div>
							</div>
						</div>

						<!-- <div :class="item.btnCls">
								{{ item.btnMsg }}
							</div> -->
						<!-- <el-button type="primary" v-if="item.is_vip=='1' && item.is_course_switch=='-1'" size="mini"
								@click="study(item)">开始学习</el-button> -->
					</div>
				</div>
			</div>
		</div>
		<el-dialog :visible.sync="dialogVisible" width="24%" :close-on-click-modal='false'>
			<div slot="title" class="dialog-header-title">
				<i icon-class="success" />
				<i class="el-icon-warning-outline"></i>
				<span>提示</span>
			</div>
			<div v-html="cont"></div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false" size="small">我再想想</el-button>
				<el-button type="primary" @click="pay()" size="small">确定缴费</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeName: 'first',
				listnew: [],
				Yeardata: [],
				year: '',
				currentTime: '',
				//缴费提示框
				dialogVisible: false,
				cont: '',
				ids: '',
				userInfo: {},
				Certificate: []
			};
		},
		created() {
			this.currentTime = this.$getCurrentTime();
			this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
			console.log(this.userInfo)
			this.getlistnew()
			this.getCertificate()
			this.getYear()
		},
		methods: {
			renderTitle(h) {
				return h('span', [
					h('i', {
						class: 'el-icon-info'
					}), // 图标
					'提示' // 标题文本
				]);
			},
			//开始学习
			study(it) {
				const that = this;

				const handleRequest = (path) => {
					that.$http({
							method: 'GET',
							url: '/edu/course_list?course_id=' + it.id + '&directory_id=' + it.edu_directory_id,
							headers: {
								requireAuth: true
							}
						})
						.then(response => {
							if (response.code == 1) {
								var durations = response.data.course_list.eduDirectory.durations
								durations.some(function(item, index) {
									if (item.progress < 100) {
										let ids = item.id
										that.$router.push({
											path: path,
											query: {
												titles: item.title,
												course_id: it.id,
												directory_id: it.edu_directory_id,
												duration_id: ids
											}
										})
										return true
									}
								})
							} else {
								that.$message(response.msg);
							}

						})
						.catch(error => {
							console.log(error)
						})
				};

				if (it.is_repeat === 1) {
					handleRequest("/videos");
				} else {
					handleRequest("/video");
				}
			},
			//选择年份
			Year(item) {
				this.listnew = []
				if (item == undefined) {
					this.year = ''
					this.getlistnew()
				} else {
					this.year = item
					this.getlistnew()
				}

			},
			//获取我的证书列表
			getCertificate() {
				this.$http({
						method: 'GET',
						url: '/edu/historyCertificate',
						headers: {
							requireAuth: true // 这里通过设置requireAuth为true来启用token检查
						},
					})
					.then(response => {
						if (response.code == 1) {
							this.Certificate = response.data.data
						} else {
							this.$message(response.msg);
						}

					})
					.catch(error => {
						console.log(error)
					})
			},
			//获取课程列表
			getlistnew() {
				this.$http({
						method: 'GET',
						url: '/edu/getlistnew?year=' + this.year,
						headers: {
							requireAuth: true // 这里通过设置requireAuth为true来启用token检查
						},
					})
					.then(response => {
						if (response.code == 1) {
							//this.listnew = response.data.eduCourse
							let classList = response.data.eduCourse;
							let nDate = new Date().getTime();
							let newCourseArr = [];
							classList.forEach(async item => {
								let sDate = Date.parse(item.sdatetime);
								let eDate = Date.parse(item.edatetime);
								if (this.Certificate.length > 0) {
									for (let i = 0; this.Certificate.length > i; i++) {
										if (this.Certificate[i].title === item.title) {
											item.bz = 1
											break
										} else {
											item.bz = 0
										}
									}
								} else {
									item.bz = 0
								}
								console.log()
								if (item.arrive === 1) {
									//未过期的课程
									if (item.is_vip === 1 && item.bz === 0) {
										//已缴费
										if (item.is_course_switch === -1) {
											//可以学习
											if (nDate > sDate && nDate < eDate) {
												//未超时，可以正常学习
												Object.assign(item, {
													courseType: 1,
													btnMsg: '开始学习',
													btnCls: 'btnCls1',
													tips: '已缴费',
													errMsg: null,
													sort: 1
												});
											} else if (nDate < sDate) {
												//未开始
												Object.assign(item, {
													courseType: 2,
													btnMsg: '未开始',
													btnCls: 'btnCls2',
													tips: `未开始`,
													errMsg: '还未到学习时间',
													sort: 2
												});
											} else if (nDate > eDate) {
												//已结束
												Object.assign(item, {
													courseType: 3,
													btnMsg: '已结束',
													btnCls: 'btnCls3',
													tips: `已结束`,
													errMsg: '学习已结束，无法学习',
													sort: 3
												});
											}
											if (item.eduGrade === -1) {
												//没有考试合格记录
												if (item.is_exam_switch === 1) {
													//正常学习完成
													Object.assign(item, {
														courseType: 4,
														btnMsg: '开始考试',
														btnCls: 'btnCls4',
														tips: '学习完成',
														errMsg: null,
														sort: 4
													});
												}
											} else if (item.eduGrade === 1) {
												//已经通过考试
												Object.assign(item, {
													courseType: 6,
													btnMsg: '考试完成',
													btnCls: 'btnCls6',
													tips: '考试已通过',
													errMsg: '考试已通过，无需重复考试',
													sort: 6
												});
											}
										} else if (item.eduGrade === -1) {
											//没有考试合格记录
											if (item.is_exam_switch === 1) {
												//正常学习完成
												Object.assign(item, {
													courseType: 4,
													btnMsg: '开始考试',
													btnCls: 'btnCls4',
													tips: '学习完成',
													errMsg: null,
													sort: 4
												});
											} else if (item.is_exam_switch === -1) {
												//学习记录已完成，但是学习课时不够
												Object.assign(item, {
													courseType: 5,
													btnMsg: '无法考试',
													btnCls: 'btnCls5',
													tips: '学习记录不正常',
													errMsg: item.msg_tip,
													sort: 5
												});
											}
										} else if (item.eduGrade === 1) {
											//已经通过考试
											Object.assign(item, {
												courseType: 6,
												btnMsg: '考试完成',
												btnCls: 'btnCls6',
												tips: '考试已通过',
												errMsg: '考试已通过，无需重复考试',
												sort: 6
											});
										}
									} else if (item.bz === 1) {
										//已经通过考试
										Object.assign(item, {
											courseType: 6,
											btnMsg: '考试完成',
											btnCls: 'btnCls6',
											tips: '考试已通过',
											errMsg: '考试已通过，无需重复考试',
											sort: 6
										});
									} else if (item.is_vip === -1 && item.is_pay === 1) {
										// console.log(item, 5);
										//未缴费
										if (nDate > sDate && nDate < eDate) {
											//未超时，可以缴费
											Object.assign(item, {
												courseType: 7,
												btnMsg: '请缴费',
												btnCls: 'btnCls7',
												tips: '未缴费',
												errMsg: null,
												sort: 7
											});
										} else if (nDate < sDate) {
											//未开始
											Object.assign(item, {
												courseType: 9,
												btnMsg: '未开始',
												btnCls: 'btnCls2',
												tips: `课程未开始`,
												errMsg: '还未到学习时间',
												sort: 9
											});
										} else {
											//过了缴费时间了
											Object.assign(item, {
												courseType: 8,
												btnMsg: '已过期',
												btnCls: 'btnCls8',
												tips: '课程已过期',
												errMsg: '课程已过期无法缴费',
												sort: 8
											});
										}
									} else if (item.is_vip === -1 && item.is_pay === -1) {
										//过了缴费时间了
										Object.assign(item, {
											courseType: 10,
											btnMsg: '暂停缴费',
											btnCls: 'btnCls8',
											tips: '课程暂停缴费',
											errMsg: '课程暂停缴费',
											sort: 10
										});
									}
									newCourseArr.push(item);
									await this.$nextTick(() => {
										this.listnew = newCourseArr;
									})

								}
							});
						} else {
							this.$message(response.msg);
						}

					})
					.catch(error => {
						console.log(error)
					})
			},

			//获取年份
			getYear() {

				this.$http({
						method: 'POST',
						url: '/edu/getYear',
						headers: {
							requireAuth: true // 这里通过设置requireAuth为true来启用token检查
						},
					})
					.then(response => {
						if (response.code == 1) {
							this.Yeardata = response.data
							this.Yeardata.sort((a, b) => b - a);
						} else {
							this.$message(response.msg);
						}

					})
					.catch(error => {
						console.log(error)
					})
			},
			play(item) {
				this.dialogVisible = true
				this.cont = item.info_content
				this.ids = item.id
			},
			//去支付
			pay() {
				this.$http({
						method: 'POST',
						url: '/order/index',
						headers: {
							requireAuth: true // 这里通过设置requireAuth为true来启用token检查
						},
						data: {
							course_id: this.ids,
						},
					})
					.then(response => {
						//alert(response)
						var tempDiv = document.createElement('div');
						tempDiv.innerHTML = response;

						var link = tempDiv.querySelector("#redirect a");
						var href = link.getAttribute("href"); // 输出 <a> 标签的 href 属性值
						window.location.href = href;

					})
					.catch(error => {
						console.log(error)
					})
			},
			//开始考试
			exam(item) {
				if (item.is_exam_switch === 1 && item.eduGrade === -1) {
					this.$router.push({
						path: "/Exam",
						query: {
							course_id: item.id
						}

					})
				} else {
					this.$message({
						message: item.msg_tip,
						type: 'warning'
					});
				}

			},
			handleClick(tab, event) {
				console.log(tab, event);
			}
		}
	};
</script>

<style scoped>
	.grid-red {
		float: right;
		padding: 17px 20px 0 0;

		font-size: 16px;
		color: #FF0000;
	}

	.el-tabs__item {
		font-size: 16px !important;
	}

	.el-dialog {
		border-radius: 11px !important;


	}

	.dialog-footer .el-button--primary {
		background-color: #0662b3;
	}

	.el-dialog__footer {
		text-align: center;
	}

	.el-button+.el-button,
	.el-checkbox.is-bordered+.el-checkbox.is-bordered {
		margin-left: 70px;
	}

	.el-dialog__header {
		padding: 10px 20px 10px;
		background: #0662b3;
		border-radius: 10px 10px 0 0;
		color: #fff;
	}

	.el-icon-warning-outline {
		font-size: 16px;
		margin-right: 5px;
	}

	.el-dialog__close {
		color: #fff !important;
	}

	.el-dialog__headerbtn {
		top: 15px;
	}

	ul {
		margin: 0 !important;
		padding: 0 !important;
	}

	.lay-tishi {
		position: absolute;
		right: 20px;
		line-height: 35px;
	}

	.lay-tishi div:nth-child(1) {
		float: left;
		line-height: 35px;
	}

	.lay-tishi div:nth-child(1) img {
		width: 27px;
		height: 24px;
	}

	.lay-tishi div:nth-child(2) {
		float: right;
		margin-left: 13px;
		line-height: 35px;
		font-size: 14px;
		font-weight: 400;
		color: #2675C5;
	}

	.cour {
		min-height: calc(100vh - 333px);

	}

	.tab {
		width: 100%;
	}

	.tag {
		height: 60px;
		background: #FFFFFF !important;
		padding-left: 10px;

	}

	.tag .el-tag {
		margin-top: 19px;
		width: 99px;
		height: 36px;
		line-height: 36px;
		margin-right: 10px;
		cursor: pointer;
		font-size: 16px;
		text-align: center;
		color: #0E75DC;
		border-color: #1072DA;
	}

	.tag .el-tag:hover {
		color: #0E75DC !important;
		border-color: #1072DA !important;
	}

	.tag .el-tag--info {
		border-color: rgba(151, 151, 151, 0.59) !important;
		background: #fff !important;
		color: #000000 !important;
	}

	.list {
		height: auto;
		width: 97%;
		padding-left: 21px !important;
		overflow: hidden;
	}

	.btnCls1 {
		background: #0082f4;
	}

	.btnCls2 {
		background: #f4c300;
	}

	.btnCls3 {
		background: #f48200;
	}

	.btnCls4 {
		background: #0091b9;
	}

	.btnCls5 {
		background: #ff0004;
	}

	.btnCls6 {
		background: #09ca0c;
	}

	.btnCls7 {
		background: #0055ff;
	}

	.btnCls8 {
		background: #ff5500;
	}

	/* 滚动条整体 */
	.list::-webkit-scrollbar {
		height: 20px;
		width: 1px;
	}

	/* 两个滚动条交接处 -- x轴和y轴 */
	.list::-webkit-scrollbar-corner {
		background-color: transparent;
	}

	/* 滚动条滑块 */
	.list::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #535353;
	}

	/* 滚动条轨道 */
	.list::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
		background: #ededed;
	}

	.list .listitem {
		width: 252px;
		height: 276px;
		margin: 25px 0px 0 24px;
		background: #FFFFFF;
		float: left;
		list-style-type: none;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
		border-radius: 6px;
	}

	.list .listitem:nth-child(1) {

		margin-left: 1px !important;

	}

	.list .listitem:nth-child(6) {

		margin-left: 1px !important;

	}

	.list .listitem:nth-child(11) {

		margin-left: 1px !important;

	}

	.list-img {
		width: 100%;
		height: 129px;
		border-radius: 6px 6px 0 0;
		overflow: hidden;
	}

	.list-img>img {
		width: 100%;
		height: auto;
		border-radius: 6px 6px 0 0;
		cursor: pointer;
		transition: all 0.6s;
	}

	.list .listitem:hover .list-img>img {
		transform: scale(1.4);
	}

	.list-tit {
		width: 92%;
		height: 50px;
		font-size: 15px;
		color: #000000;
		line-height: 22px;
		margin: 8px auto;
		font-weight: 500;
	}

	.list-time {
		width: 92%;
		font-size: 14px;
		color: #969696;
		line-height: 22px;
		margin: 8px auto;
		font-weight: 500;
	}

	.list-start {
		width: 92%;
		height: 27px;
		margin: 10px auto;
		line-height: 27px;
	}

	.list-start .list-start-img {
		float: left;
	}

	.list-start .list-start-img>img {
		width: 20px;
		height: 20px;
		padding-top: 3px;
	}

	.list-start .list-start-cont div:nth-child(1) {
		float: left;
		margin-left: 3px;
		font-size: 16px;
		font-weight: 400;

	}

	.list-start .list-start-cont div:nth-child(2) {
		float: right;
		margin-left: 3px;
	}

	.list-start .list-start-cont .el-tag {
		padding: 0 !important;
		width: 70px !important;
		height: 26px !important;
		text-align: center;
	}

	.list-start .list-start-cont .el-button {
		padding: 0 !important;
		width: 70px !important;
		height: 26px !important;
		line-height: 26px !important;
		text-align: center;
	}
</style>